export default {
  en: {
    remark: 'Remark',
    edit: 'Edit'
  },
  th: {
    remark: 'หมายเหตุ',
    edit: 'แก้ไข'
  }
}
